<template>
  <div>
    <Navigation />
    <div class="main-container">
      <div class="container">
        <h1 class="is-size-2">{{ title | capitalize }} Dashboard</h1>
      </div>
      <div class="container">
        <div class="columns">
          <div class="column">
            <template v-if="columns.length && tableData.length">
              <p class="has-text-right mb-1">
                <button class="button is-success" @click="e => createItem(e)">
                  New {{ singularItem[title] }}
                </button>
              </p>
              <table class="table is-bordered is-striped is-fullwidth">
                <tr>
                  <th v-for="(c, i) in columns" :key="c + '-' + i">
                    {{ c | cleanTitle | capitalize }}
                  </th>
                  <th>
                    Actions
                  </th>
                </tr>
                <tr v-for="(tr, index) in tableData" :key="'row-' + index">
                  <td
                    v-for="(entry, i) in Object.entries(tr)"
                    :key="'data-' + i"
                  >
                    <template
                      v-if="
                        !['image', 'content', 'created', 'edited'].includes(
                          columns[i]
                        )
                      "
                    >
                      <template
                        v-if="
                          entry[0] === 'file' &&
                            entry[1].indexOf('pdf') > -1 &&
                            entry[1].indexOf('PDF') > -1
                        "
                      >
                        {{ entry[1] }}
                      </template>
                      <template
                        v-if="
                          entry[0] === 'file' &&
                            entry[1].indexOf('pdf') === -1 &&
                            entry[1].indexOf('PDF') === -1
                        "
                      >
                        <figure class="image is-96x96 image-overflow">
                          <img :src="getImage(entry[1])" v-if="entry[1]" />
                        </figure>
                      </template>
                      <template v-else>
                        {{ entry[1] }}
                      </template>
                    </template>
                    <template v-else-if="['image'].includes(columns[i])">
                      <figure class="image is-64x64 image-overflow">
                        <img :src="getImage(entry[1])" v-if="entry[1]" />
                        <img src="@/assets/placeholder.png" v-else />
                      </figure>
                    </template>
                    <template
                      v-else-if="['created', 'edited'].includes(columns[i])"
                    >
                      <small>{{ entry[1] | niceDate }}</small>
                    </template>
                  </td>
                  <td>
                    <button
                      @click="e => editItem(e, tr)"
                      class="button is-info is-small"
                    >
                      <span :title="'Edit ' + singularItem[title]">
                        <i class="fas fa-edit"></i>
                      </span>
                    </button>
                    <button
                      @click="() => deleteItem(tr)"
                      class="button is-danger is-small"
                    >
                      <span
                        :title="
                          'Remove ' + singularItem[title] + ' from ' + title
                        "
                      >
                        <i class="fas fa-trash"></i>
                      </span>
                    </button>
                  </td>
                </tr>
              </table>
            </template>
            <template v-else-if="columns.length && !tableData.length">
              <p class="has-text-right mb-1">
                <button class="button is-success" @click="e => createItem(e)">
                  New {{ singularItem[title] }}
                </button>
              </p>
              <table class="table is-bordered is-striped is-fullwidth">
                <tr>
                  <th v-for="(c, i) in columns" :key="c + '-' + i">
                    {{ c | cleanTitle | capitalize }}
                  </th>
                </tr>
                <tr>
                  <td :colspan="columns.length" class="has-text-centered">
                    No {{ title }} available.
                  </td>
                </tr>
              </table>
            </template>
            <template v-else>
              Loading...
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import axios from "axios";
import moment from "moment";
import singularItem from "@/helpers/singularItems.js";

export default {
  name: "Dashboard",
  data() {
    return {
      columnNames: [],
      tableDataRows: [],
      singularItem: singularItem
    };
  },
  mounted() {
    if (!this.columns.length && !this.tableData.length) this.getData();
  },
  components: {
    Navigation: Navigation
  },
  filters: {
    capitalize(value) {
      if (value && value !== "agm")
        return value[0].toUpperCase() + value.substring(1);
      else if (value && value === "agm") return value.toUpperCase();
      else return value;
    },
    cleanTitle(value) {
      if (value) return value.replace(/_/g, " ");
      else return value;
    },
    niceDate(value) {
      if (value) return moment(value).format("MMMM Do YYYY, h:mm a");
      else return value;
    }
  },
  methods: {
    getImage(img) {
      return process.env.VUE_APP_SERVER + "uploads/" + img;
    },
    createItem(e) {
      // Send user to create form.
      e.preventDefault();
      this.$router.push({
        name: "Form",
        params: { type: "create", title: this.title }
      });
    },
    editItem(e, item) {
      // Send user to update form.
      e.preventDefault();
      this.$router.push({
        name: "Form",
        params: { type: "edit", id: item.id, title: this.title }
      });
    },
    deleteItem(item) {
      axios
        .delete(process.env.VUE_APP_SERVER + this.title + "/delete/" + item.id)
        .then(res => {
          if (res.data.message.indexOf("Success") > -1) {
            this.$noty.success(singularItem[this.title] + " has been removed.");
            this.tableData = this.tableData.filter(t => t.id !== item.id);
          }
        })
        .catch(error => {
          this.$noty.error(singularItem[this.title] + " couldn't be removed.");
          console.error(error);
        });
    },
    getData() {
      axios
        .get(process.env.VUE_APP_SERVER + this.title)
        .then(res => {
          if (res.data && res.data.result) {
            this.tableData = res.data.result.map(r => {
              const columns = {};
              Object.keys(r).forEach(k => {
                if (
                  k !== "content" &&
                  k !== "description" &&
                  k !== "template"
                ) {
                  columns[k] = r[k];
                }
              });
              return columns;
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
      axios
        .get(process.env.VUE_APP_SERVER + "fields/" + this.title)
        .then(res => {
          if (res.data && res.data.result) {
            this.columns = res.data.result.filter(
              c => c !== "content" && c !== "description" && c !== "template"
            );
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  watch: {
    title() {
      this.getData();
    }
  },
  computed: {
    title() {
      return this.$route.params.page;
    },
    tableData: {
      get() {
        return this.tableDataRows;
      },
      set(value) {
        this.tableDataRows = value;
      }
    },
    columns: {
      get() {
        return this.columnNames;
      },
      set(value) {
        this.columnNames = value;
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/basic.scss";
</style>
